import React from "react";
import DatasetMetricSourceSelector, {
  type ResolvedMetricSelection,
} from "./DatasetMetricSourceSelector";
import {
  isMetricEligibleForLineChart,
  lineChartMetricNeedsQuestionDetailFetch,
  buildLineChartFocusParamsFromMetric,
  metricHasPercentageOrMeanResultType,
  type LineChartMetricFocusParams,
} from "@components/charts/line-chart-metric-utils";

export type ResolvedLineChartMetricSelection = ResolvedMetricSelection<LineChartMetricFocusParams>;

interface LineChartMetricSourceSelectorProps {
  datasetId: string;
  onResolvedChange: (selection: ResolvedLineChartMetricSelection | null) => void;
}

/** Line Chart's Metric source picker — thin wrapper over the shared
 *  DatasetMetricSourceSelector (PRD-67 reuses PRD-66's Bar Chart picker),
 *  supplying Line Chart's own Percentage-or-Mean eligibility. */
const LineChartMetricSourceSelector: React.FC<LineChartMetricSourceSelectorProps> = ({
  datasetId,
  onResolvedChange,
}) => (
  <DatasetMetricSourceSelector<LineChartMetricFocusParams>
    datasetId={datasetId}
    resultTypeFilter={metricHasPercentageOrMeanResultType}
    isEligible={isMetricEligibleForLineChart}
    needsQuestionDetailFetch={lineChartMetricNeedsQuestionDetailFetch}
    buildFocusParams={buildLineChartFocusParamsFromMetric}
    eligibilityCaption="Percentage and Mean metrics can be used in a Line Chart."
    noMetricsMessage="No metrics found in this dataset yet."
    onResolvedChange={onResolvedChange}
  />
);

export default LineChartMetricSourceSelector;
